<template>
<div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <h2 class="text-lg font-medium mr-auto">Packet Issue Transactions</h2>
        <!-- <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <router-link
          :to="{ name: 'add-issue-packet' }"
          tag="button"
           class="btn btn-primary shadow-md mr-2">
           New Issue
          </router-link>
      </div> -->
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
        <div class="grid grid-cols-12 gap-5">
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
              <div>
                  <label for="update-profile-form-6" class="form-label pt-2">Transaction No</label>
                  <input id="tabulator-html-filter-value" v-model="filter.value" type="text" class="form-control 2xl:w-full" placeholder="Transaction No" @click="onFilter" />
              </div>
          </div>
            <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
                <div>
                    <label for="update-profile-form-6" class="form-label pt-2">Select Process</label>
                    <TomSelect v-model="screenData.process_id" @change="getEmployeeDetails" :options="{
                  placeholder: 'Select Process',
                  loadingClass: 'loading',
                  plugins: {
                    dropdown_header: {
                      title: 'Process'
                    }
                  }
                }" class="w-full">
                        <option value="0">Select Process</option>
                        <option value="manager_transfer">Manager Transfer</option>
                        <option v-for="item in screenData.process_items" :key="item.id" :value="item.id">{{item.process_name}} ( {{ item.process_short_code ? item.process_short_code : '-' }} )</option>
                    </TomSelect>
                </div>
            </div>
            <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2" v-if="[1,2,8].includes(userDetails.user_role) ">
                <div>
                    <label for="update-profile-form-6" class="form-label pt-2">Employee Type</label>
                    <TomSelect v-model="screenData.employee_type" @change="getEmployeeDetails" :options="{
                placeholder: 'Select Employee Type',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Employee Type'
                  }
                }
              }" class="w-full">
                        <option value="1">Employee</option>
                        <!-- <option value="2">Planner / Checker</option> -->
                        <option value="3">Job Party</option>
                    </TomSelect>
                </div>
            </div>
            <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2" v-if="[1,2,8].includes(userDetails.user_role) ">
                <div>
                    <label for="update-profile-form-6" class="form-label pt-2">Select Employee</label>
                    <TomSelect v-model="screenData.employee_id" :options="{
                placeholder: 'Select Employee',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Employee'
                  }
                }
              }" class="w-full">
                        <option value="0">Select Employee</option>
                        <option v-for="item in screenData.employees" :key="item.id" :value="item.id">{{item.first_name}} {{item.last_name}} ( {{ item.process_short_code ? item.short_code : '-' }} )</option>
                    </TomSelect>
                </div>
            </div>
            <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2" v-if="[1,2,8].includes(userDetails.user_role) ">
                <div>
                    <label for="update-profile-form-6" class="form-label pt-2">Select Employee</label>
                    <TomSelect v-model="screenData.status" :options="{
                placeholder: 'Select Employee',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Employee'
                  }
                }
              }" class="w-full">
                        <option value="0">Select Status</option>
                        <option value="1">Pending</option>
                        <option value="2">Accepted</option>
                        <option value="3">In Process</option>
                        <option value="4">Returned</option>
                        <option value="5">Cancelled</option>
                    </TomSelect>
                </div>
            </div>
            <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
              <div class="flex mt-9">
                <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full sm:w-16" @click="initTabulator">
                    Go
                </button>
                <button id="tabulator-html-filter-reset" type="button" class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1" @click="onResetFilter">
                    Reset
                </button>
              </div>
            </div>
            <div class="col-span-12">
                    <div class="flex flex-wrap justify-end">

                        <div class="text-sm font-bold mr-4">Total Jangad: {{ screenData.total.total_jangad ? screenData.total.total_jangad : 0 }}</div>
                        <div class="text-sm font-bold mr-4">Total PCS: {{ screenData.total.total_packets ? screenData.total.total_packets : 0 }}</div>
                        <div class="text-sm font-bold">Total WT(Ct): {{ screenData.total.issue_weight ? $h.myFloat(screenData.total.issue_weight) : 0 }} Ct</div>
                    </div>
                </div>
        </div>
        <div class="overflow-x-auto scrollbar-hidden">
            <div id="tabulator" ref="tableRef" class="mt-5"></div>
        </div>
    </div>
    <!-- END: HTML Table Data -->
</div>
</template>

<script>
import {
    defineComponent,
    computed,
    ref,
    reactive,
    onMounted,
    inject
} from 'vue'
import xlsx from 'xlsx'
import {
    useStore
} from '@/store'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import VueRouter from 'vue-router'
import {
    useRouter,
    useRoute
} from 'vue-router'
import {
    BASE_URL
} from '@/constants/config.js'
import moment from 'moment'

export default defineComponent({
    setup() {
        const router = useRouter()
        const store = useStore()
        const route = useRoute()
        const tableRef = ref()
        const tabulator = ref()
        const filter = reactive({
            field: 'lot_no',
            type: 'like',
            value: ''
        })

        const swal = inject('$swal')
        const userDetails = computed(() => store.state.user.currentUser)

        const screenData = reactive({
            issuer: '',
            status: '0',
            employee_type: '3',
            employee_id: '',
            process_id: '0',
            employees: [],
            process_items: [],
            emp_hit: 1,
            total: {
              "total_jangad": 0,
              "total_packets": 0,
              "issue_weight": 0
            }
        })

        const initTabulator = () => {

          localStorage.setItem('transaction_filters', JSON.stringify({
            employee_type: screenData.employee_type,
            employee_id: screenData.employee_id,
            process_id: screenData.process_id,
            status: screenData.status,
          }))
            let _this = this;
            tabulator.value = new Tabulator(tableRef.value, {
                ajaxURL: BASE_URL + 'api/purchase/packet_transactions_by_user',
                ajaxConfig: {
                    method: "GET", //set request type to Position
                    headers: {
                        "Content-type": 'application/json; charset=utf-8', //set specific content type
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                },
                ajaxParams: {
                    transaction_no: filter.value == '' ? '' : window.btoa(filter.value),
                    employee_type: screenData.employee_type == '0' ? '' : window.btoa(screenData.employee_type),
                    employee_id: screenData.employee_id == '0' ? '' : window.btoa(screenData.employee_id),
                    process_id: screenData.process_id == '0' ? '' : window.btoa(screenData.process_id),
                    status: screenData.status == '0' ? '' : window.btoa(screenData.status),
                },
                ajaxFiltering: true,
                ajaxSorting: true,
                printAsHtml: true,
                printStyled: true,
                pagination: 'remote',
                paginationSize: 20,
                paginationSizeSelector: [20, 30, 40],
                layout: 'fitColumns',
                responsiveLayout: false,
                tooltipsHeader: true,
                headerSort: false,
                placeholder: 'No matching records found',
                columns: [

                    // For HTML table
                    {
                        title: 'Transaction No',
                        minWidth: 200,
                        responsive: 0,
                        field: 'transaction_code',
                        vertAlign: 'middle',
                        print: false,
                        download: true,

                        formatter(cell) {
                            // const a = cash(`<div class="w-full m-0">
                            //    <div class="whitespace-nowrap">${
                            //      cell.getData().due
                            //    }</div>
                            //  </div>`)
                            //  cash(a).on('click', function () {
                            //    Packet(cell.getData().id, cell.getData().lot_no, cell.getData().type)
                            //  })
                            //  return a[0]
                            if (cell.getData().issue_by == userDetails.value.id) {
                                const a = cash(`<div><i data-feather="arrow-up-right" class="w-6 h-6 font-bold text-theme-9 mr-1"></i>
                 ${
                  cell.getData().transaction_code
                 }
                </div>`)
                                cash(a).on('click', function () {
                                    router.push({
                                        'path': '/packets/transaction/' + window.btoa(cell.getData().id)
                                    })
                                })
                                return a[0]
                            } else {
                                const a = cash(`<div><i data-feather="arrow-down-left" class="w-6 h-6 font-bold text-theme-6 mr-1"></i>
                 ${
                  cell.getData().transaction_code
                 }
                </div>`)
                                cash(a).on('click', function () {
                                    router.push({
                                        'path': '/packets/transaction/' + window.btoa(cell.getData().id)
                                    })
                                })
                                return a[0]
                            }
                        }
                    },
                    {
                        title: 'Party Jangad No',
                        field: 'memo_no',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: true,
                    },
                    {
                        title: 'Pieces',
                        field: 'pieces',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: true,
                    },
                    {
                        title: 'Issue Weight',
                        field: 'issue_weight',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: true,
                        formatter(cell) {
                            return `<div class="text-md">
                <p class="font-12 font-bold text-md">` + Number(cell.getData().issue_weight).toFixed(4) + ` ct </p>
              </div>`;
                        }
                    },
                    {

                        title: 'Manager/Worker',
                        field: 'karigar_first_name',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: true,
                        formatter(cell) {
                            if (cell.getData().issue_by == userDetails.value.id) {

                                if (cell.getData().transaction_type == 1) {
                                    return `<div class="">` + cell.getData().issue_manager_first_name + ' ' + cell.getData().issue_manager_last_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Transfer' + `</p>
                </div>`;
                                } else if (cell.getData().transaction_type == 2) {
                                    if ([1,2,5,6,7,8,10,11,12].includes(cell.getData().process_type)) {

                                        if (cell.getData().employee_role == 7) {
                                            return `<div class="">` + cell.getData().karigar_first_name + ' ' + cell.getData().karigar_last_name + `<br>
                          <p class="text-theme-9 font-12 font-bold">` + cell.getData().process_name + `</p>
                      </div>`;
                                        } else if (cell.getData().employee_role == 4) {
                                            return `<div class="">` + cell.getData().pp_first_name + ' ' + cell.getData().pp_last_name + `<br>
                          <p class="text-theme-9 font-12 font-bold">` + cell.getData().process_name + `</p>
                      </div>`;
                                        }
                                    } else if (cell.getData().process_type == 3 || cell.getData().process_type == 4) {
                                        return `<div class="">` + cell.getData().planner_first_name + ' ' + cell.getData().planner_last_name + `<br>
                          <p class="text-theme-9 font-12 font-bold">` + cell.getData().process_name + `</p>
                      </div>`;
                                    }
                                } else if (cell.getData().transaction_type == 4) {
                                    return `<div class="">` + cell.getData().issue_manager_first_name + ' ' + cell.getData().issue_manager_last_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Job Done' + `</p>
                </div>`;
                                } else if (cell.getData().transaction_type == 3) {
                                    return `<div class="">` + cell.getData().issue_manager_first_name + ' ' + cell.getData().issue_manager_last_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Process Done' + `</p>
                </div>`;
                                }

                            } else {
                                if (cell.getData().transaction_type == 1) {
                                    return `<div class="">` + cell.getData().manager_first_name + ' ' + cell.getData().manager_last_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Transfer' + `</p>
                </div>`;
                                } else if (cell.getData().transaction_type == 2) {
                                    return `<div class="">` + cell.getData().manager_first_name + ' ' + cell.getData().manager_last_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Transfer' + `</p>
                </div>`;
                                } else if (cell.getData().transaction_type == 4) {
                                    return `<div class="">` + cell.getData().manager_first_name + ' ' + cell.getData().manager_first_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Job Done' + `</p>
                </div>`;
                                } else if (cell.getData().transaction_type == 3) {
                                    return `<div class="">` + cell.getData().manager_first_name + ' ' + cell.getData().manager_first_name + `<br>
                  <p class="text-theme-9 font-12 font-bold">` + 'Process Done' + `</p>
                </div>`;
                                }
                            }
                        }
                    },
                    {
                        title: 'Issue/ Receive Date',
                        field: 'created_at',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: true,
                        formatter(cell) {
                            return moment(cell.getData().created_at).format('D/M/YYYY hh:mm:ss') +  '<br>' + (cell.getData().receive_date ? moment(cell.getData().receive_date).format('D/M/YYYY hh:mm:ss') : '-');

                        }
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                            if (cell.getData().transaction_type == 1) {
                              if (cell.getData().transaction_status == 1 && cell.getData().status == 1) {
                                        return `<div class="flex items-center lg:justify-center text-theme-1">
                      On Hold
                    </div>`
                                    } else if (cell.getData().transaction_status == 2 && cell.getData().status == 1) {
                                        if (cell.getData().issue_by == userDetails.value.id) {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Accepted
                      </div>`
                                        } else {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Accepted
                      </div>`

                                        }
                                    } else if (cell.getData().status == 2) {
                                        if (cell.getData().issue_by == userDetails.value.id) {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Received
                      </div>`
                                        } else {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Accepted
                      </div>`

                                        }
                                    } else if (cell.getData().transaction_status == 3) {
                                        return `<div class="flex items-center lg:justify-center text-theme-6">
                      Cancelled
                    </div>`
                                    }
                            } else if (cell.getData().transaction_type == 2) {
                                if ([1,2,5,6,7,8,10,11,12].includes(cell.getData().process_type)) {
                                    if (cell.getData().status == 1) {
                                        return `<div class="flex items-center lg:justify-center font-bold text-theme-9">
                    In Process
                  </div>`
                                    } else if (cell.getData().status == 2) {
                                        return `<div class="flex items-center lg:justify-center text-theme-6">
                    Received
                    </div>`
                                    } else if (cell.getData().status == 3) {
                                        return `<div class="flex items-center lg:justify-center text-theme-6">
                      Cancelled
                    </div>`
                                    }
                                } else if (cell.getData().process_type == 3 || cell.getData().process_type == 4 || cell.getData().process_type == 5) {
                                    if (cell.getData().transaction_status == 1 && cell.getData().status == 1) {
                                        return `<div class="flex items-center lg:justify-center text-theme-1">
                      On Hold
                    </div>`
                                    } else if (cell.getData().transaction_status == 2 && cell.getData().status == 1) {
                                        if (cell.getData().issue_by == userDetails.value.id) {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      In Process
                      </div>`
                                        } else {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Accepted
                      </div>`

                                        }
                                    } else if (cell.getData().status == 2) {
                                        if (cell.getData().issue_by == userDetails.value.id) {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Received
                      </div>`
                                        } else {
                                            return `<div class="flex items-center lg:justify-center text-theme-9">
                      Accepted
                      </div>`

                                        }
                                    } else if (cell.getData().transaction_status == 3) {
                                        return `<div class="flex items-center lg:justify-center text-theme-6">
                      Cancelled
                    </div>`
                                    }
                                }
                            } else if (cell.getData().transaction_type == 4) {
                                if (cell.getData().transaction_status == 1 || cell.getData().status == 1) {
                                    return `<div class="flex items-center lg:justify-center text-theme-1">
                    On Hold
                  </div>`
                                } else if (cell.getData().status == 2) {
                                    return `<div class="flex items-center lg:justify-center text-theme-9">
                  Accepted
                  </div>`
                                } else if (cell.getData().transaction_status == 3) {
                                    return `<div class="flex items-center lg:justify-center text-theme-6">
                    Cancelled
                  </div>`
                                }
                            } else if (cell.getData().transaction_type == 3) {
                                if (cell.getData().transaction_status == 1 || cell.getData().status == 1) {
                                    return `<div class="flex items-center lg:justify-center text-theme-1">
                    On Hold
                  </div>`
                                } else if (cell.getData().status == 2) {
                                    return `<div class="flex items-center lg:justify-center text-theme-9">
                  Accepted
                  </div>`
                                } else if (cell.getData().transaction_status == 3) {
                                    return `<div class="flex items-center lg:justify-center text-theme-6">
                    Cancelled
                  </div>`
                                }
                            }
                        }
                    },
                    {
                        title: '',
                        minWidth: 80,
                        field: '',
                        responsive: 1,
                        hozAlign: 'center',
                        vertAlign: 'middle',
                        headerSort: false,
                        print: false,
                        download: false,
                        formatter(cell) {
                            const data_id = cell.getData().id;

                            if (cell.getData().transaction_status == 1 && cell.getData().status == 1 && ([1, 4].includes(cell.getData().transaction_type) || [3,4,5].includes(cell.getData().process_type))) {
                                if (cell.getData().issue_by == userDetails.value.id) {
                                    if (cell.getData().transaction_status == 1) {
                                        const a = cash(`<div class="flex lg:justify-center items-center">
                      <button class="btn btn-primary btn-sm flex items-center mr-3">
                        <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Withdraw
                      </button>
                    </div>`)
                                        cash(a).on('click', function () {
                                            editTransactionStatus(cell.getData().id, cell.getData().issue_by, 'withdraw');
                                        })
                                        return a[0]
                                    }
                                } else if (cell.getData().issue_by != userDetails.value.id) {

                                    const a = cash(`<div class="flex lg:justify-center items-center">
                      <button class="btn btn-primary btn-sm flex items-center mr-3">
                        <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Accept
                      </button>
                    </div>`)
                                    cash(a).on('click', function () {
                                        editTransactionStatus(cell.getData().id, cell.getData().issue_by, 'accept');
                                    })

                                    return a[0]

                                }
                            }
                        }
                    },

                ],
                renderComplete() {
                    feather.replace({
                        'stroke-width': 1.5
                    })
                }
            })

            let api_url = ''

                if (filter.department_id == '0') {

                    api_url = 'api/purchase/packet_transactions_by_user_total'
                } else {
                    api_url = 'api/purchase/packet_transactions_by_user_total'
                }
                let promise = axios({
                    url: api_url,
                    method: "post",
                    data: {
                      transaction_no: filter.value == '' ? '' : window.btoa(filter.value),
                      employee_type: screenData.employee_type == '0' ? '' : window.btoa(screenData.employee_type),
                      employee_id: screenData.employee_id == '0' ? '' : window.btoa(screenData.employee_id),
                      process_id: screenData.process_id == '0' ? '' : window.btoa(screenData.process_id),
                      status: screenData.status == '0' ? '' : window.btoa(screenData.status),
                    },
                    baseURL: BASE_URL,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    config: {
                        headers: {
                            Accept: "application/json"
                        }
                    }
                });
                return promise
                    .then(result => result.data)
                    .then(data => {
                        screenData.total = data.item
                      })
                      .catch(_error => {
                        screenData.total.total_jangad = 0
                        screenData.total.total_packets = 0
                        screenData.total.issue_weight = 0
                    });
        }

        const getEmployeeDetails = () => {

            if (screenData.process_id == 'manager_transfer') {
                screenData.employee_id = '0'
                screenData.employees = []
                // initTabulator()
            } else {

                let params = {
                    employee_type: window.btoa(screenData.employee_type),
                    process_id: screenData.process_id == '0' ? '' : window.btoa(screenData.process_id),
                }
                let api_url = ''

                if (filter.department_id == '0') {

                    api_url = 'api/master/get_employees_by_manager_employee_type'
                } else {
                    api_url = 'api/master/get_employees_by_manager_employee_type'
                }
                let promise = axios({
                    url: api_url,
                    method: "post",
                    data: params,
                    baseURL: BASE_URL,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    config: {
                        headers: {
                            Accept: "application/json"
                        }
                    }
                });
                return promise
                    .then(result => result.data)
                    .then(data => {
                        screenData.employees = data.items
                        if (screenData.employee_id != '0') {

                          if(screenData.emp_hit == 2) {


                            screenData.employee_id = '0'
                          } else {
                            screenData.emp_hit++;
                          }
                        } else {

                            // initTabulator()
                            // screenData.employee_id = '0'
                        }
                    })
                    .catch(_error => {
                        screenData.employees = []
                        // initTabulator()
                        if (screenData.employee_id != '0') {

                          if(screenData.emp_hit == 2) {

                            screenData.employee_id = '0'
                          } else {
                            screenData.emp_hit++;
                          }
                        } else {

                            // initTabulator()
                            // screenData.employee_id = '0'
                        }
                    });
            }

        }

        const getProcessDetails = async () => {
            let params = {
                // id: window.btoa(screenData.manager_id)
            }
            let api_url = ''

            if (filter.manager_id == '0') {

                api_url = 'api/master/dp_process'
            } else {
                api_url = 'api/master/dp_process'
            }
            let promise = axios({
                url: api_url,
                method: "post",
                data: params,
                baseURL: BASE_URL,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                config: {
                    headers: {
                        Accept: "application/json"
                    }
                }
            });
            return promise
                .then(result => result.data)
                .then(data => {
                    // screenData.process_id = '0'
                    screenData.process_items = data.items
                })
                .catch(_error => {
                    // screenData.process_id = '0'
                    screenData.process_items = []
                });
        }

        // Redraw table onresize
        const reInitOnResizeWindow = () => {
            window.addEventListener('resize', () => {
                tabulator.value.redraw()
                feather.replace({
                    'stroke-width': 1.5
                })
            })
        }

        // Filter function
        const onFilter = () => {
            tabulator.value.setFilter(filter.field, filter.type, filter.value)
        }

        //Edit user
        const editUser = (id) => {
            console.log(id);
        }

        //Edit user
        const editTransactionStatus = (id, user_id, action) => {
            console.log(id);
            console.log(user_id);
            let trans_id = id;
            let sender_type = '';
            if (user_id == userDetails.value.id) {
                sender_type = "sender";
            } else {
                sender_type = "receiver";
            }

            const params = {
                "trans_id": trans_id,
                'sender_type': sender_type,
                'action': action
            };

            swal({
                title: "Are you sure?",
                text: "You are about to Change transaction status!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm & Accept",
                showLoaderOnConfirm: true,
                cancelButtonText: "Cancel",

                preConfirm: login => {

                    let promise = axios({
                        url: "api/purchase/hold_action_packet_trans",
                        method: "post",
                        data: params,
                        baseURL: BASE_URL,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token")
                        },
                        config: {
                            headers: {
                                Accept: "application/json"
                            }
                        }
                    });
                    return promise
                        .then(result => result.data)
                        .then(data => {
                            console.log(data.message);
                            if (data.status == "error") {
                                swal("Error!", data.message, "error");
                            } else {
                                router.go();
                            }
                        })
                        .catch(_error => {
                            return [];
                        });
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then(result => {
                if (result.value) {
                    //swal("Success!", "User Password Updated.", "success");
                }
            });
        }

        // On reset filter
        const onResetFilter = () => {
            filter.field = 'first_name'
            filter.type = 'like'
            filter.value = ''
            screenData.status =  '0'
            screenData.employee_type =  '3'
            screenData.employee_id =  ''
            screenData.process_id =  '0'
            onFilter()
        }

        // Export
        const onExportCsv = () => {
            tabulator.value.download('csv', 'data.csv')
        }

        const onExportJson = () => {
            tabulator.value.download('json', 'data.json')
        }

        const onExportXlsx = () => {
            const win = window
            win.XLSX = xlsx
            tabulator.value.download('xlsx', 'buyer_list.xlsx', {
                sheetName: 'Buyers'
            })
        }

        const onExportHtml = () => {
            tabulator.value.download('html', 'data.html', {
                style: true
            })
        }

        // Print
        const onPrint = () => {
            tabulator.value.print()
        }

        onMounted(() => {

          const filters =  JSON.parse(localStorage.getItem('transaction_filters'))

          console.log(filters)

          if(filters) {

            screenData.employee_type = (filters.employee_type ? filters.employee_type : '3')
            screenData.employee_id = (filters.employee_id ? filters.employee_id : '0')
            screenData.process_id = (filters.process_id ? filters.process_id : '0')
            screenData.status = (filters.status ? filters.status : '0')
          }
          getEmployeeDetails()
          getProcessDetails()
          initTabulator()
            reInitOnResizeWindow()
        })

        return {
            tableRef,
            screenData,
            userDetails,
            filter,
            onFilter,
            onResetFilter,
            onExportCsv,
            onExportJson,
            onExportXlsx,
            onExportHtml,
            initTabulator,
            getEmployeeDetails,
            onPrint,
            editUser
        }

    }
})
</script>
